import { render, staticRenderFns } from "./AllClientVendorReport.vue?vue&type=template&id=05f22399&scoped=true&"
import script from "./AllClientVendorReport.vue?vue&type=script&lang=js&"
export * from "./AllClientVendorReport.vue?vue&type=script&lang=js&"
import style0 from "./AllClientVendorReport.vue?vue&type=style&index=0&id=05f22399&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f22399",
  null
  
)

component.options.__file = "AllClientVendorReport.vue"
export default component.exports